<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="currentColor" d="m7.5 3l7.5 8H0l7.5-8Z"/></svg>
</template>
